
import { ReviewStatus } from "../constants/dealer-basic-data";
import { ReviewReply } from "./review-reply.model";

export class Review {

    id: string = "";

    raterId: string = "";
    ratedId: string = "";
    
    rate: number = 0;
    comment: string = "";

    raterEmail: string = "";
    raterName: string = "";
    nameIsPublic: boolean = false;
    
    country: string = "";
    city: string = "";
    status: ReviewStatus = ReviewStatus.TO_CHECK;
    
    created = "";
    lastUpdated = "";

    replies: ReviewReply [] = [];

    newReply: ReviewReply = new ReviewReply();

    constructor(){
        this.replies = [];
        this.newReply = new ReviewReply();
    }
 }